/* eslint-disable import/prefer-default-export */
/*
* This file is used for additional tokens (i.e. not Colors or Typography).
* Colors and Typography have their tokens inside their own primitives.
* */

/** Canonical Graphie stack for branch blocks, header, and primitives. */
export const fontGraphie = 'Graphie, sans-serif';

/** Menu/nav surfaces: Graphie first, then system UI fallbacks (Figma header spec). */
export const fontGraphieMenuStack = 'Graphie, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const borderRadius = {
    small: '3px',
    medium: '6px',
    large: '10px',
    full: '5000px',
};

export const rowPadding = {
    standardDesktop: '16px',
    largeDesktop: '32px',
    full: '65px',
};

export const maxDesignWidth = 1920; // matches GridContextProvider `maxWidth` (px) for desktop-first design

/**
 * Layout grid tiers — align with GridContextProvider `dt` / `tb` / `mb`.
 * `mobile` matches `breakpoints.mb` (4-col). `tablet` is the 768–1200 band only.
 */
export const gridBreakpoints = {
    mobile: '@media (max-width: 767px)',
    tablet: '@media (min-width: 768px) and (max-width: 1200px)',
} as const;

export const breakpoints = {
    dt: '@media screen',
    uw: '@media (min-width: 1920px)',
    headerTb: '@media (max-width: 1300px)',
    tb: '@media (max-width: 1200px)',
    mb: '@media (max-width: 767px)',
    // new for future setup will ditch the above once fully implemented
    ultraWide: '@media (max-width: 1920px)',
    largeDesktop: '@media (max-width: 1600px)',
    standardDesktop: '@media (max-width: 1440px)',
    commonLaptop: '@media (max-width: 1366px)',
    smallLaptop: '@media (max-width: 1280px)',
    smallDesktop: '@media (max-width: 1200px)',
    tablet: '@media (max-width: 1024px)',
    largeTablet: '@media (max-width: 992px)',
    tabletPortrait: '@media (max-width: 768px)',
    largePhone: '@media (max-width: 576px)',
};
